<template>
    <!-- Ventana de filtros (se abre desde el botón "Filtros", como en Notion). Los
         cambios se aplican al instante; Esc o clic afuera la cierran. -->
    <div ref="pop" class="cr-fpop" role="dialog" :aria-label="crm.t('f.title')" :style="estilo">
        <div class="cr-fpop-head">
            <h3>{{ crm.t('f.title') }}</h3>
            <button v-if="crm.nFiltros" type="button" class="cr-btn-link" @click="limpiar">{{ crm.t('f.clear') }}</button>
            <button type="button" class="cr-ico-btn" :aria-label="crm.t('close')" @click="$emit('cerrar')" v-html="I.close"></button>
        </div>
        <div class="cr-fpop-body">
            <section class="cr-fgrp">
                <h4>{{ crm.t('f.pri') }}</h4>
                <div class="cr-seg">
                    <button v-for="k in ['alta', 'media', 'baja']" :key="k" type="button" class="cr-chip" :aria-pressed="String(crm.F.pri === k)" @click="crm.F.pri = crm.F.pri === k ? '' : k">
                        <span v-html="crm.priPill(k)"></span><span class="cr-n">{{ crm.conteoPri[k] }}</span>
                    </button>
                </div>
            </section>
            <section class="cr-fgrp">
                <h4>{{ crm.t('f.show') }}</h4>
                <div class="cr-seg">
                    <button v-for="o in solos" :key="o.k" type="button" class="cr-chip" :aria-pressed="String(crm.F.solo === o.k)" @click="crm.toggleSolo(o.k)"><span v-html="o.ic"></span>{{ o.t }}</button>
                </div>
            </section>
            <section v-for="d in crm.filtrosDD" :key="d.k" class="cr-fgrp">
                <h4>{{ d.titulo }}</h4>
                <button type="button" class="cr-fld-dd" :class="{ 'is-on': !!crm.F[d.k] }" aria-haspopup="listbox" aria-expanded="false" @click="crm.abrirFiltro($event, d)">
                    <span class="cr-fdd-v">{{ d.actual }}</span><span class="cr-chev" v-html="I.chev"></span>
                </button>
            </section>
        </div>
        <div class="cr-fpop-foot">
            <span>{{ crm.visibles.length === crm.tarjetas.length ? crm.tc('head.n', crm.tarjetas.length) : crm.t('head.of', { a: crm.visibles.length, b: crm.tarjetas.length }) }}</span>
            <button type="button" class="cr-btn cr-btn-main cr-btn-sm" @click="$emit('cerrar')">{{ crm.t('f.done') }}</button>
        </div>
    </div>
</template>

<script>
import { I } from './crmUtil';

export default {
    name: 'CrmFiltros',
    inject: ['crm'],
    props: { anchor: { type: null, default: null } },
    data() { return { I, pos: { top: 0, left: 0, w: 380 } }; },
    computed: {
        estilo() { return { top: this.pos.top + 'px', left: this.pos.left + 'px', width: this.pos.w + 'px' }; },
        solos() {
            return [
                { k: 'sin', t: this.crm.t('stat.pending'), ic: I.user },
                { k: 'tarde', t: this.crm.t('f.late'), ic: I.clock },
                { k: 'seg', t: this.crm.t('f.follow'), ic: I.flag },
            ];
        },
    },
    mounted() {
        this.ubicar();
        this.$nextTick(() => { const f = this.$refs.pop.querySelector('.cr-chip, button'); if (f) f.focus(); });
        // Clic afuera cierra (salvo en el botón que la abre o en un desplegable que abrió ella).
        this._afuera = e => {
            if (this.$el.contains(e.target) || (this.anchor && this.anchor.contains(e.target)) || e.target.closest('.cr-pop')) return;
            this.$emit('cerrar');
        };
        this._ubicar = () => this.ubicar();
        this._esc = e => { if (e.key === 'Escape' && !document.querySelector('.cr-pop')) { e.preventDefault(); this.$emit('cerrar'); } };
        document.addEventListener('keydown', this._esc);
        setTimeout(() => document.addEventListener('mousedown', this._afuera, true), 0);
        window.addEventListener('resize', this._ubicar);
        window.addEventListener('scroll', this._ubicar, true);
    },
    beforeDestroy() {
        document.removeEventListener('mousedown', this._afuera, true);
        document.removeEventListener('keydown', this._esc);
        window.removeEventListener('resize', this._ubicar);
        window.removeEventListener('scroll', this._ubicar, true);
        if (this.anchor && this.anchor.isConnected) this.anchor.focus();
    },
    methods: {
        ubicar() {
            if (!this.anchor) return;
            const r = this.anchor.getBoundingClientRect(), w = Math.min(380, innerWidth - 16);
            this.pos = { w, top: r.bottom + 8, left: Math.max(8, Math.min(r.right - w, innerWidth - w - 8)) };
        },
        limpiar() { ['pri', 'asig', 'tipo', 'ciudad', 'solo'].forEach(k => { this.crm.F[k] = ''; }); },
    },
};
</script>
